type TextInputProps = {
  type?: 'text' | 'email' | 'password';
  placeholder: string;
  value: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  required?: boolean;
  disabled?: boolean;
};

export const TextInput: React.FC<TextInputProps> = ({
  type = 'text',
  placeholder,
  value,
  onChange,
  className = '',
  required = false,
  disabled = false,
}) => {
  return (
    <input
      type={type}
      placeholder={placeholder}
      className={`p-4 pt-3 pb-3 border bg-white rounded-xl outline-none text-sm ${className}`}
      value={value}
      onChange={onChange}
      required={required}
      disabled={disabled}
    />
  );
};

interface SelectionCardProps {
  title: string;
  subTitile: string;
  isSelected: boolean;
  onClick?: (event: React.FormEvent) => void;
}

export default function SelectionCard(props: SelectionCardProps) {
  return (
    <div
      onClick={props.onClick}
      className={`flex flex-row h-[105px] rounded-md p-6 bg-white
                ${props.isSelected ? 'border border-black' : 'border border-slate-300 hover:border-[#252629]'}  
                cursor-pointer`}
    >
      <div className="w-full">
        <div className="text-lg	font-medium">{props.title}</div>
        <div className="text-sm">{props.subTitile}</div>
      </div>
    </div>
  );
}
